import React from 'react';
import Cutouts from '../../../Cutouts';
import styles from './HolidayBanner.module.css';

/** @type {Object<FF.HolidayTypes, string>} */
const HOLIDAY_ANIMATIONS = {
  WINTER: React.lazy(() => import('./WinterAnimation')),
  SPRING: React.lazy(() => import('./SpringAnimation')),
  SUMMER: React.lazy(() => import('./SummerAnimation')),
  FALL: React.lazy(() => import('./FallAnimation')),
};

/** @type {Object<FF.HolidayTypes, FF.CutoutShapes>} */
const HOLIDAY_TYPE_CUTOUT_CONFIG = {
  WINTER: { orientation: 'Right', shape: 'Line Cuts' },
  SPRING: { orientation: 'Left', shape: 'Half Circles' },
  SUMMER: { orientation: 'Left', shape: 'Small Zig Zag' },
  FALL: { orientation: 'Left', shape: 'Big Zig Zag' },
};

/**
 * @param {object} props
 * @param {FF.HolidayTypes} props.type
 */
export default function HolidayBanner({ type }) {
  const HolidayAnimation = HOLIDAY_ANIMATIONS[type];
  return (
    <div
      className={`${
        styles[`wrapper${type.slice(0, 1)}${type.slice(1).toLowerCase()}`]
      }`}
    >
      <div className={styles.textContent}>
        <h2 className={styles.header}>We&apos;re Taking a Vacation!</h2>
        <h3 className={styles.subtitle}>
          {type === 'WINTER'
            ? 'This Farmer’s Fridge location is closed for the holidays. After a year with all hands on deck, we are giving our team some well-deserved time off. We look forward to serving you again in the New Year.'
            : 'This Farmer’s Fridge location is closed for the holidays. We look forward to serving you again after the break.'}
        </h3>
      </div>
      <Cutouts
        className={styles.cutout}
        cutouts={[
          {
            ...HOLIDAY_TYPE_CUTOUT_CONFIG[type],
            color: '',
          },
        ]}
        noPadding
      >
        <div className={styles.cutoutsWrapper} />
      </Cutouts>
      <div className={styles.holidayAnimation}>
        <HolidayAnimation />
      </div>
    </div>
  );
}
